/**
 * Loading state for the dynamic-hint filter list. Replaces the legacy
 * MUI spinner with a column of skeleton rows that mirror the shape
 * of the option rows the user is about to see — same height, same
 * spacing — so the UI doesn't visibly "jump" when items arrive. The
 * `.qhs-shimmer` utility (see `tokens.css`) handles the gradient
 * sweep + dark-theme palette for free.
 */
const ROWS = [70, 55, 80, 45, 65, 50, 75];

const StyledLoader = () => {
  return (
    <div className='qhs-dynh-loader' aria-hidden='true'>
      {ROWS.map((width, idx) => (
        // Static array — using `width-idx` as a synthetic key keeps
        // the render stable without relying on plain array indices.
        <div
          key={`${width}-${idx}`}
          className='qhs-dynh-loader__row qhs-shimmer'
          style={{ width: `${width}%` }}
        />
      ))}
    </div>
  );
};

export default StyledLoader;
